<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="modal-inner">
        <div class="close-btn">
          <div class="btn-close" @click="onModalClose"></div>
        </div>
        <div class="custom-modal-header">
          <div class="title">
            <i class="fas fa-folder"></i>
            <span>Workflow hinzufügen</span>
          </div>
        </div>
        <div class="custom-modal-content">
          <div class="mt-5" v-if="isLoading">
            <LoadingSpinner loadingCaption="loading data" />
          </div>
          <div v-if="!isLoading">
            <div class="form-group">
              <div class="label">Knopftext</div>
              <input
                v-model="buttonLabel"
                ref="inputref"
                @input="onInputChange"
                type="text"
              />
            </div>
          </div>
          <div v-if="!isLoading" class="error-message-container">
            <span v-if="showError">Please fill the details</span>
          </div>
          <div v-if="!isLoading" class="wrapped-content">
            <ObjectMapper
              v-if="this.elements"
              :databaseSchema="JSON.stringify(this.elements)"
              :defaultItems="editObjectValues"
              ref="objectMapperRef"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="save-btn" @click="onAddModalSave">speichern</button>

          <button class="cancel-btn" @click="onModalClose">verwerfen</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import ObjectMapper from '../widgets/object-mapper.vue';

export default {
  name: 'AddWorkFlowModal',
  data() {
    return {
      buttonLabel: null,
      showError: false,
    };
  },
  props: {
    workFlowModal: {
      required: true,
      type: Object,
      default: () => ({
        visible: false,
        loading: false,
        selectedFlow: {},
        elements: [],
        mode: null,
        linkName: '',
        editParentID: null,
        editObjectvalues: {},
      }),
    },
  },
  computed: {
    isLoading() {
      return this.workFlowModal.loading;
    },
    selectedFlow() {
      return this.workFlowModal.selectedFlow;
    },
    mode() {
      return this.workFlowModal.mode;
    },
    linkName() {
      return this.workFlowModal.linkName;
    },
    elements() {
      return this.workFlowModal.elements;
    },
    editObjectValues() {
      return this.workFlowModal.editObjectvalues;
    },
  },
  methods: {
    onInputChange(e) {
      if (
        e.target.value &&
        e.target.value !== '' &&
        e.target.value.trim() !== '' &&
        e.target.value !== null
      ) {
        e.target.classList.value = '';
      }
    },
    onModalClose() {
      this.$emit('closeModal');
    },
    onAddModalSave() {
      if (this.buttonLabel === '' || this.buttonLabel === null) {
        const inputref = this.$refs.inputref;
        if (inputref) {
          inputref.classList.value = 'error-input';
        }
      } else {
        const baseurl = `https://flow-runner.api.codelos.io/v4/run_flow_by_id?id=${this.selectedFlow.id}&`;
        const output = this.$refs.objectMapperRef.getOutputJson;

        if (output && Object.keys(output).length > 0) {
          let paramsString = '';
          Object.keys(output).map((key, i) => {
            let paramBreak = Object.keys(output).length === i + 1 ? '' : '&';

            paramsString += `${key}=${output[key]}` + paramBreak;
          });

          const finalUrl = baseurl + paramsString;

          const uniqueId = Date.now();
          const editImage = `<img data-url="${finalUrl}" data-parent-id="hrefbtn${uniqueId}" data-flow-id=${this.selectedFlow.id} data-flow-link-name="${this.buttonLabel}" class="rich-text-email-button-edit-icon" style=" height: 16px;margin-left: 7px;margin-top: -25px;visibility: hidden;transition: all 100ms ease-in-out;cursor: pointer;"  src='data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACKklEQVRoge2YPS8EQRjHn1xJo+IofAgiEhWlRkdE3EnwAeglGnwBHwKtoJNTo0ROxVVe4iUSEu/neTI3MWZndmd3x85ssr/k31xuZn7P3szOkwPwg0HMDuYJ84I5wIy6FIrDNOYd05TyjVly6GXEJOYDgvJilp3ZRVDBfMJf2WvMBeSgCNWTr2O6MW2YffC4iDB5jrdFmMhzvCtCJ98TMsabIqoQPLBnmLLB2HZMDYJFZPaKVck3wEyeoyqC7ol/v+xU8s3WZ1Mx51IVUbNmqkAnn7aIS2GOZ0uuAXR7vg7piujC3AjjH+0p/6KTp8XpdZm0iHJrHnHstmX3UHlOkiJU8tQADmQtz4lThEr+C1gvZY04NyyHCjuFYBGiWCfmRCE/Y1tefvJR8pywIjKRj7NtdOi2UwOC8lVb4kSaJy+j+iW83TY6dEXkQp7w/sCGUchHUcgrKOSjKOQVFPJR5Fq+0po0TWOmogvU/bzVxoz+XHqDnMoTY5DTbcNZlBYaTzlfpvLEurRYX4q5Mpcn9qQFOxLO40SeOBcWvEs4hzP5EuZVWPQwwRzO5IleaeGNmOOdyhMj0uIrMcY6lyfmJYFZw3FeyBNrksRwyHfp7dQP7J7I5IY1YUsSGQJWxBxmFbMJ7GDfS9/zQp44DhEziZNtI/KgkDINNYBW/yVOwhVEi9I9QQ3eLrC2YwFYA5i24bPCBOYW2C9xBOxM0MGmM0CvWLonSs7sIvgBueEUoFfIfwIAAAAASUVORK5CYII=' >`;
          const hrefBtn = `<p id="hrefbtn${uniqueId}" contenteditable='false' class="workflow-button-wrapper"><a class="link-button" style="cursor: pointer;text-decoration: none;border: 3px solid rgba(0, 0, 0, 0.916);border-radius: 0.375em;font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;font-weight: 400;line-height: 23px;padding: 0.6rem 1.6rem;font-size: 0.9375rem;margin-top: 5px;letter-spacing: 0.6px;text-transform: uppercase;min-width: 125px;background-color: rgba(0, 0, 0, 0.916);color: rgba(255, 255, 255, 0.951);" href='${finalUrl}' rel='noopener noreferrer' target='_blank'>${this.buttonLabel}</a>${editImage}</p>`;
          this.$emit('onAddModalSave', hrefBtn);
        } else {
          this.showError = true;
        }
      }
    },
  },
  created() {
    if (this.mode === 'edit') {
      this.buttonLabel = this.linkName;
    }
  },
  components: {
    LoadingSpinner,
    ObjectMapper,
  },
};
</script>
<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  padding: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 10px;
  display: block;
}

.modal .modal-inner {
  width: 90%;
  height: auto;
  background: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  height: 98%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 1147px;
  padding-top: 35px;
  border: solid 0.05px #c3c4c6;
  border-radius: 13px;
  -webkit-box-shadow: 0 1px 10px rgb(0 0 0 / 15%), 0 2.4px 5.7px rgb(0 0 0 / 2%),
    0 4px 11.3px rgb(0 0 0 / 2%), 0 10.6px 17.5px rgb(0 0 0 / 2%),
    0 14px 25.7px rgb(0 0 0 / 3%), 0 35.5px 39.6px rgb(0 0 0 / 4%),
    0 40px 48px rgb(0 0 0 / 3%);
  box-shadow: 0 1px 10px rgb(0 0 0 / 15%), 0 2.4px 5.7px rgb(0 0 0 / 2%),
    0 4px 11.3px rgb(0 0 0 / 2%), 0 10.6px 17.5px rgb(0 0 0 / 2%),
    0 14px 25.7px rgb(0 0 0 / 3%), 0 35.5px 39.6px rgb(0 0 0 / 4%),
    0 40px 48px rgb(0 0 0 / 3%);
}
.modal .btn-close {
  position: absolute;
  right: 15px;
  top: 10px;
  padding: 0;
}
.custom-modal-header {
  box-sizing: border-box;
  display: block;
  position: relative;
  padding-bottom: 10px;
  padding: 0px 31px;
}
.modal .btn-close:focus {
  outline: none;
  box-shadow: none;
}

.custom-modal-header .title {
  font-size: 22px;
  color: #525252;
  float: none;
  margin-right: 0;
  padding-right: 0;
}

.custom-modal-header .title i {
  margin-right: 20px;
}

.custom-modal-content {
  min-height: 150px;
  margin: 20px 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.custom-modal-content .error-message-container {
  margin-top: 20px;
  color: red;
  display: flex;
  justify-content: flex-end;
}

.custom-modal-content .wrapped-content {
  flex-grow: 1;
  padding: 10px 5px 5px 5px;
  margin-top: 5px;
  padding: 20px 30px;
  overflow-y: auto;
}

.custom-modal-content .form-group .error-input {
  border: 1px solid red;
}

.modal .modal-footer {
  justify-content: center;
  margin-bottom: 0;
  padding-bottom: 0;
  padding-top: 0;
  border: 0;
}

.modal .modal-footer button {
  cursor: pointer;
  text-decoration: none;
  border: 3px solid rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-top: 5px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  min-width: 125px;
}

.modal .modal-footer .save-btn {
  background-color: rgba(0, 0, 0, 0.916);
  color: rgba(255, 255, 255, 0.951);
}
.modal .modal-footer .cancel-btn {
  color: rgba(0, 0, 0, 0.916);
  background-color: white;
}

.form-group {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 20px 30px;
}

.form-group .label {
  text-transform: none;
  width: 160px;
}

.form-group input {
  width: 50%;
  cursor: text;
  background: none;
  height: 100%;
  padding: 8px 5px 8px 5px;
  border: 1px solid #dee3e9;
}

input:focus {
  outline: none;
}
.custom-modal-content
  .wrapped-content::v-deep
  .object-mapper
  input[type='text'] {
  padding: 8px 5px 8px 5px !important;
}

.custom-modal-content
  .wrapped-content::v-deep
  .object-mapper
  input[type='text']:focus {
  outline: none;
}

::v-deep .wrapped-content .database-form label {
  width: 160px;
  text-align: left;
}

::v-deep .wrapped-content .database-form input {
  width: 50%;
}
</style>
